// Import Packages
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DateFnsUtils from '@date-io/date-fns';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import 'prismjs/components/prism-powershell';

// Import Pages

import EventConfiguration from '../FlowConfigurationInputs/EventConfiguration/EventConfiguration';
import ActiveDirectory from './ActiveDirectory';
import Database from './Database';
import Automs from './Automs';
import Excel from './Excel';
import Word from './Word';
import Repeatable from './Repeatable';
import RESTful from './RESTful';
import TimeManagement from './TimeManagement';
import Condition from './Condition';
import String from './String';
import DataTable from './DataTable';
import Dictionary from './Dictionary';
import Array from './Array';
import ServiceDesk from './ServiceDesk';
import DisplayMessage from './DisplayMessage';
import File from './File';
import Pdf from './Pdf';
import Folder from './Folder';
import Number from './Number';
import Ocr from './Ocr';
import Ews from './EWS';
import Email from './Email';
import Data from './Data';
import PreProcessing from './PreProcessing';
import Models from './Models';
import EndPoint from './EndPoint';
import DesktopRecorder from './DesktopRecorder';
import Stop from './Stop';
import Grouping from './Grouping';
import Python from './Python';
import Javascript from './Javascript';
import PowerShell from './PowerShell';
import Object from './Object';
import Csv from './CSV';
import DateAction from './Date';
import AdvancedActions from './AdvancedActions';
import CustomAction from './CustomAction';
import Whatsapp from './Whatsapp';
import MicrosoftTeams from './MicrosoftTeams';
import SSH from './SSH';
import Cryptography from './Cryptography';
import BASE64 from './Base64';
import TEXT from './Text';
import AutomMate from './AutomMate';
import FtpSftp from './FtpSftp';
import MyChatGPT from './MyChatGPT';
import MateDrive from './MateDrive';
import MateDB from './MateDb';

import { types } from './types';
import {
    alertState,
    lastFocusField,
    selectedField,
    inputRefresh,
    triggerConf,
    showObjectExplorerIcon,
    renameTime,
    baseOrigin
} from '../../recoil-store/recoil-state';
import TriggerStatic from "./TriggerStatic";
import ConnectorField from "../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";

// Import Helpers
import { findActionById } from '../../helpers/helper';

// Import Material UI
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createTheme, MuiThemeProvider, makeStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ArrowRight from '@material-ui/icons/ArrowRight';

// Import Icons
import actionControlIcon from '../../assets/icons/action-control-icon.svg';
import minimizeIcon from '../../assets/icons/minimize-icon.svg';

// Import CSS
import './FlowConfiguration.css';

const useStyles = makeStyles({
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    }
});

const Libraries = React.memo((props) => {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    // const setInputRefreshGlobal = useSetRecoilState(inputRefresh);
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    //const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const changeRename = useRecoilValue(renameTime);

    //const [triggerConfig, setTriggerConfig] = useState(null);


    const setFocusField = useSetRecoilState(lastFocusField);
    const [showOEIcon, setShowOEIcon] = useRecoilState(showObjectExplorerIcon);
    const [actions, setActions] = useState([]);
    const [selectedAction, setSelectedAction] = useState({});
    const base_origin = useRecoilValue(baseOrigin);
    const classes = useStyles();
    const selectedOptionRef = useRef(null);
    //const [selectedFieldValue] = useRecoilState(selectedField);
    // const sysActionFielName = 'sys_action_fields';

    // useEffect(() => {
    //     if (selectedFieldValue.path.length && focusField.inputName) {

    //         const valueEndIndex = selectedFieldValue.path.indexOf('[')
    //         let firstValue;
    //         let secondValue;
    //         if (valueEndIndex !== -1) {
    //             firstValue = selectedFieldValue.path.substring(2, valueEndIndex)
    //             secondValue = selectedFieldValue.path.substring(valueEndIndex)
    //         } else {
    //             firstValue = selectedFieldValue.path.substring(2, selectedFieldValue.path.length - 2)
    //             secondValue = selectedFieldValue.path.substring(selectedFieldValue.path.length - 2);
    //         }
    //         let v;
    //         if (selectedFieldValue.key === '') {
    //             v = `##${firstValue}${secondValue}`;
    //         } else {
    //             v = `##${selectedFieldValue.key}[${firstValue}]${secondValue}`;
    //         }
    //         if (!focusField.is_sys_field) {
    //             if (props.selectedAction.fields[focusField.inputName].value) {
    //                 props.selectedAction.fields[focusField.inputName].value += v;
    //             } else {
    //                 props.selectedAction.fields[focusField.inputName].value = v;
    //             }

    //         } else {
    //             props.selectedAction.fields[sysActionFielName].value[focusField.inputName].value = v;
    //         }
    //         setInputRefreshGlobal(new Date());
    //     }
    // }, [selectedFieldValue])

    useEffect(() => {
        let isMounted = true; // Flag to track mount status
        const checkAndSet = async () => {
            if (props.fromFlow) {
                if (!showOEIcon) {
                    setShowOEIcon(true)
                }
                let a = [];
                await findActions(a, props.automDetail.items);
                if (isMounted) {
                    setActions(a);
                }
                if (props.selectedAction) {
                    let s = a.find(x => x.item_id === props.selectedAction.item_id);
                    if (s) {
                        setSelectedAction(s);
                    }
                }

            } else {
                if (showOEIcon) {
                    setShowOEIcon(false)
                }
            }
            setFocusField({
                inputName: '',
                type: '',
                is_sys_field: false
            })
        }
        checkAndSet().then(r => r);

        // Cleanup function to set isMounted to false when the component unmounts
        return () => {
            isMounted = false;
        };
    }, [props.selectedAction?.item_id])

    useEffect(() => {
        const ListActions = async () => {
            let a = [];
            await findActions(a, props.automDetail.items);
            setActions(a);
            if (props.selectedAction) {
                let s = a.find(x => x.item_id === props.selectedAction.item_id);
                if (s) {
                    setSelectedAction(s);
                }
            }
        }
        if (props.fromFlow) {
            ListActions().then(r => r);
        }
    }, [changeRename])

    const findActions = (a, items) => {
        return new Promise(async (resolve) => {
            for (const item of items) {
                if (!['START', 'TRIGGER-STATIC'].find(x => x === item.libraryName)) {
                    if (item.library_label) {
                        let actionOrjName = item.library_label.includes('CUSTOM') ? item?.library_name + " - " + item.name :
                            (item.libraryName === 'STOP' ? '' : t(`CONTENT.LIBRARY.${item.libraryName}.NAME`) + " - ") +
                            t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
                        let name = item.label ? item.label :
                            actionOrjName;
                        try {
                            // Checking if there is an item with the same name
                            const f = a.filter(x => x.name.includes(name))
                            if (f.length) {
                                let num = 1;
                                // found the largest number at the end of the name
                                for (const it of f) {
                                    const y = it.name.split(/[()]/)[1];
                                    if (y) {
                                        let n = parseInt(y)
                                        if (n > num) {
                                            num = n;
                                        }
                                    }
                                }
                                // number added to name
                                name += ` (${num + 1})`
                            }
                        } catch (error) {
                        }

                        a.push({ item_id: item.item_id, name, actionOrjName, image: item.image, image_path: item.image_path ? item.image_path : '' })
                    }

                    if (item.children) {
                        await findActions(a, item.children)
                    }
                }
            }
            resolve(true);
        })
    }

    const showAlert = (message, status = false) => {
        setAlert(alert => ({ ...alert, show: true, message, severity: status ? 'success' : 'error' }));
    };

    const closeRightArea = () => {
        props.setShowRightArea(false);
        props.setShowTriggerRightArea(false);
    }

    const ConfigurationContent = (action) => {
        if (action) {
            action.mate_id = props.mateId;
            if (!action.fields) {
                action.fields = {};
            }
            if (action?.libraryLabel?.includes('CUSTOM')) {
                return CustomAction(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.debuggingStart, props.debuggingExpand, props.automVersionId, props.automId, props.setVariables, props.automDetail, props.setAutomDetail, props.fromFlow, props.getVariables);
            }
            switch (action.libraryName) {
                case types.ACTIVEDIRECTORY:
                    return ActiveDirectory(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId);
                case types.AUTOMMATE:
                    return AutomMate(action, props.variables, props.setOpenVariable, props.variableRender, props.automVersionId, props.automId, props.setVariables, props.automDetail, props.setAutomDetail);
                case types.AUTOMS:
                    return Automs(action, showAlert, props.variables, props.setOpenVariable, props.findElementName, props.getAutomNamesIDs);
                case types.DATABASE:
                    return Database(action, showAlert, props.variables, props.setOpenVariable, props.variableRender);
                case types.EXCEL:
                    return Excel(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.getVariables, props.variableRender, props.automDetail);
                case types.WORD:
                    return Word(action, showAlert, props.variables, props.setOpenVariable, props.automId);
                case types.REPEAT:
                    return Repeatable(action, showAlert, props.variables, props.setOpenVariable, props.variableRender);
                case types.RESTFUL:
                    return RESTful(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.getVariables);
                case types.TIME:
                    return TimeManagement(action, showAlert, props.variables, props.setOpenVariable);
                case types.CONDITION:
                    return Condition(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId, props.automDetail);
                case types.STRING:
                    return String(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setField, props.disabled, props.outputVisible, props.visible);
                case types.DATATABLE:
                    return DataTable(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automDetail, props.visible);
                case types.DICTIONARY:
                    return Dictionary(action, showAlert, props.variables, props.setOpenVariable);
                case types.ARRAY:
                    return Array(action, showAlert, props.variables, props.setOpenVariable, props.visible);
                case types.SERVICEDESK:
                    return ServiceDesk(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automVersionId);
                case types.DISPLAYMESSAGE:
                    return DisplayMessage(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.FILE:
                    return File(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.BASE64:
                    return BASE64(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.TEXT:
                    return TEXT(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.getVariables);
                case types.PDF:
                    return Pdf(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.automVersionId);
                case types.FOLDER:
                    return Folder(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.NUMBER:
                    return Number(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setField, props.disabled, props.outputVisible, props.visible);
                case types.OCR:
                    return Ocr(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.EWS:
                    return Ews(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.EMAIL:
                    return Email(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.DATA:
                    return Data(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.PREPROCESSING:
                    return PreProcessing(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automVersionId);
                case types.MATEDRIVE:
                    return MateDrive(action, props.variables, props.setOpenVariable, props.automId);
                case types.MODELS:
                    return Models(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.ENDPOINT:
                    return EndPoint(action, showAlert, props.variables, props.setOpenVariable, props.findElementName, props.getAutomNamesIDs, props.allFlow);
                case types.DESKTOPACTIONS:
                    return DesktopRecorder(action, showAlert, props.variables, props.setOpenVariable, props.drecorder, props.setRender, props.automId, props.actions, props.automVersionId, props.fromFlow, props.setField);
                case types.STOP:
                    return !props.isEhFlow && Stop(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.variableRender);
                case types.GROUPING:
                    return Grouping(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel, props.actions, props.isEhFlow);
                case types.PYTHON:
                    return Python(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel, props.automId);
                case types.JAVASCRIPT:
                    return Javascript(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel, props.automId);
                case types.OBJECT:
                    return Object(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.disabled, props.automId, props.automVersionId, props.automDetail, props.visible);
                case types.CSV:
                    return Csv(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.POWERSHELL:
                    return PowerShell(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel, props.automId);
                case types.DATE:
                    return DateAction(action, props.variables, props.setOpenVariable, props.variableRender, props.visible);
                case types.ADVANCEDACTIONS:
                    return AdvancedActions(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.automDetail, props.setAutomDetail, props.isEhFlow, props.actions);
                case types.TRIGGERSTATIC:
                    return TriggerStatic(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.automVersionId);
                case types.WHATSAPP:
                    return Whatsapp(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automaticallyWhatsappVariableCreation, props.getVariables, props.actions);
                case types.MICROSOFTTEAMS:
                    return MicrosoftTeams(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automaticallyWhatsappVariableCreation, props.getVariables);
                case types.SSH:
                    return SSH(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId);
                case types.CRYPTOGRAPHY:
                    return Cryptography(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId);
                case types.FTPSFTP:
                    return FtpSftp(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId);
                case types.MYCHATGPT:
                    return MyChatGPT(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automaticallyWhatsappVariableCreation, props.getVariables, props.actions);
                case types.MATEDB:
                    return MateDB(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automaticallyWhatsappVariableCreation, props.getVariables, props.actions);
                default:
                    break;
            }
        }
    };

    const changeActiveAction = async (e, newValue) => {
        setSelectedAction(newValue);
        if (newValue) {
            let copyItem = await findActionById(newValue.item_id, props.automDetail.items);
            if (!copyItem) {
                showAlert("Action not found please try again")
                console.log('item not found');
                return
            }
            props.setActiveItem(e, copyItem, "INPUT-SELECT");
        } else {
            props.setActiveItem(e, []);
        }
    }
    const handleClickActiveAction = async (e, value) => {
        const intervalId = setInterval(() => {
            if (selectedOptionRef.current) {
                selectedOptionRef.current.scrollIntoView({
                    behavior: 'auto',
                    block: 'start', // block 'start' seçili öğeyi listenin en üstüne getirir
                });
                clearInterval(intervalId)
            }
        }, 100);
        setTimeout(() => {
            clearInterval(intervalId)
        }, 1000);
    }

    const label = 'CONTENT.CONFIGURATION-FORM.' + props.selectedAction?.libraryName + '.';
    const actionName = label + props.selectedAction?.actionName;
    return (
        <MuiThemeProvider theme={getMuiTheme()}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div id="configuration-container" style={{ padding: props?.selectedAction?.actionName === "HOVER" || props?.selectedAction?.actionName === "HOVER" && !props?.fromFlow && "0" }}>
                    {props.fromFlow &&
                        <>
                            <div className='action-header-container'>
                                <div className="action-header-container">
                                    <img src={actionControlIcon} />
                                    <span className='margin-left-10'>
                                        {t("CONTENT.FLOW.ACTION-CONTROL-CENTER")}
                                    </span>
                                </div>
                                <img className='minimize-icon' src={minimizeIcon}
                                    onClick={() => props.setShowRightArea(false)} />
                            </div>
                            <div className='action-selection-content'>
                                <div className='select-action-label'>Select Action</div>
                                <Autocomplete
                                    value={selectedAction}
                                    onChange={(e, newValue) => changeActiveAction(e, newValue)}
                                    onOpen={(e, newValue) => handleClickActiveAction(e, newValue)}
                                    id="size-small-outlined-multi"
                                    style={{ width: 300, position: 'relative', background: '#FBFBFB' }}
                                    size="small"
                                    options={actions}
                                    classes={{
                                        option: classes.option,
                                    }}
                                    autoHighlight
                                    getOptionLabel={(option) => option.name ?? ""}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(option) => (
                                        <>
                                            <img
                                                loading="lazy"
                                                width="20"
                                                src={option.image_path ? `${base_origin}${option.image_path}` : option.image}
                                                alt=""
                                                style={{ marginRight: '10px' }}
                                            />
                                            <div ref={option?.name === selectedAction?.name ? selectedOptionRef : null} className="elipsis-nowrap">{option?.name}</div>
                                        </>
                                    )}
                                    renderInput={(params) => (
                                        <>
                                            {
                                                selectedAction && selectedAction.image &&
                                                <img className='input-action-icon' src={selectedAction.image_path ? `${base_origin}${selectedAction.image_path}` : selectedAction.image} />
                                            }
                                            <TextField
                                                {...params}
                                                className="select-action-input"
                                                placeholder="No Action Selected"
                                                variant="outlined"
                                                classes={{
                                                    root: classes.resize
                                                }}
                                                inputProps={{
                                                    ...params.inputProps,
                                                    "aria-autocomplete": 'new-password',
                                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                                    style: {
                                                        marginLeft: '36px',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: '#46474E'
                                                    }
                                                }}
                                            />
                                        </>
                                    )}
                                />
                            </div>
                            {/* <div id={props.selectedAction?.actionName ? 'configuration-header' : 'without-header'}>
                        {
                            props.selectedAction?.actionName &&
                            <span>
                                {props.selectedAction?.libraryLabel?.includes('CUSTOM') ? props.selectedAction?.libraryName :
                                    <span>{t(label + 'HEADER')}</span>}
                                {props.selectedAction?.libraryLabel !== 'TRIGGERSTATIC' &&
                                    <span>&nbsp; &gt; &nbsp;</span>}
                                {props.selectedAction?.libraryLabel === 'TRIGGERSTATIC' ? "" :
                                    props.selectedAction?.libraryLabel?.includes('CUSTOM') ? props.selectedAction?.actionName :
                                        <span>{t(actionName + '.HEADER')}</span>}
                            </span>
                        }
                    </div> */}
                            <hr id="configuration-seperator" />
                        </>
                    }


                    <div>{ConfigurationContent(props.selectedAction)}</div>
                    { //
                        props.fromFlow && !props.selectedAction?.libraryLabel?.includes('CUSTOM') && props.selectedAction?.actionName !== 'START' &&
                        props.selectedAction?.actionName !== 'DATA-TRANSFORM' &&
                        props.selectedAction?.actionName !== 'FILTER' && props.selectedAction?.actionName !== 'KEY-PRESS' &&
                        !props.selectedAction?.libraryLabel?.includes('CONDITION') && //triggerConfig?.connector?.id &&
                        <ConnectorField automDetail={props.automDetail} action={props.selectedAction} showFieldPreview={true}
                            triggerConfig={triggerConfig} triggerExpanded={true}
                            debugOpen={props.debuggingStart} debugExpand={props.debuggingExpand}
                            onFlowPage={true}
                            setTriggerConf={setTriggerConfig} automId={props.automId}
                            automVersionId={props.automVersionId} rightLocation={true}
                            variables={props.variables} setOpenVariable={props.setOpenVariable} />
                    }
                    {props.selectedAction?.actionName && !props.outputVisible && props.selectedAction.actionName !== 'GO-TO' && !props.isEhFlow &&
                        <EventConfiguration setField={props.setField} action={props.selectedAction}
                            setDialog={props.setDialog}
                            setDetailTabs={props.setDetailTabs}
                            setTabFilter={props.setTabFilter}
                            variables={props.variables} setOpenVariable={props.setOpenVariable} justContinue={props.visible ? true : false} />}
                </div>

            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    );
});

export default Libraries;

const getMuiTheme = () => createTheme({
    overrides: {
        MuiOutlinedInput: {
            input: { padding: '8px 5px' },
            multiline: { padding: '8px 5px' }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(8px, 8px) scale(1)'
            }
        },
        MuiInputBase: {
            root: { fontSize: '.8rem' }
        },
        MuiListSubheader: {
            root: { lineHeight: 'unset' }
        },
        MuiMenuItem: {
            root: { fontSize: '0.8rem' }
        },
        PrivateNotchedOutline: {
            legendLabelled: { fontSize: 'unset' }
        },
        MuiTab: {
            root: {
                '@media (min-width: 600px)': { minWidth: 'unset' },
                width: 'min-content',
                whiteSpace: 'nowrap',
                padding: '0 10px'
            }
        },
        MuiButton: {
            outlined: {
                padding: '3px 10px',
                textTransform: 'none'
            }
        },
        MuiFormControlLabel: {
            label: {
                fontSize: 12,
                fontWeight: 600
            }
        }
    }
});
